import { render, staticRenderFns } from "./supplierManageList.vue?vue&type=template&id=0dcb2e93&scoped=true"
import script from "./supplierManageList.vue?vue&type=script&lang=js"
export * from "./supplierManageList.vue?vue&type=script&lang=js"
import style0 from "./supplierManageList.vue?vue&type=style&index=0&id=0dcb2e93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb2e93",
  null
  
)

export default component.exports